import { render, staticRenderFns } from "./new-message.vue?vue&type=template&id=610e4c81&scoped=true"
import script from "./new-message.vue?vue&type=script&lang=js"
export * from "./new-message.vue?vue&type=script&lang=js"
import style0 from "./new-message.vue?vue&type=style&index=0&id=610e4c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e4c81",
  null
  
)

export default component.exports